import { Box } from "@mui/material";
import Flex from "../../../../../../../components/Flex";
import PatientChronologicalAndRequiringActionLayout from "../patient-chronological-records-and-requiring-actions/patientChronologicalAndRequiringActionLayout";
import PatientCommunicationLayoutNew from "./PatientCommunicationLayoutNew";
import { CHART_COLORS } from "../../../../../../../components/app/provider/patient/chart";

const PatientCommunicationLayoutNewChart = () => {
  const isVisitNotePage = window.location.pathname.includes("/visit-note");

  if (isVisitNotePage) {
    return <PatientCommunicationLayoutNew />;
  }

  return (
    <Flex width={"100%"} gap={1}>
      <Box width={"50%"}>
        <PatientChronologicalAndRequiringActionLayout
          shouldHideCreateVisitNote
          showColumnView
        />
      </Box>
      <Box borderLeft={"1px solid" + CHART_COLORS.border} width={"50%"}>
        <PatientCommunicationLayoutNew />
      </Box>
    </Flex>
  );
};

export default PatientCommunicationLayoutNewChart;
